module.exports = __webpack_public_path__ + "img/slide_portatil.1022a13b.jpg";